"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalAttributesComparison = exports.SignalReviewAttributesRowSchema = void 0;
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const signal_attributes_denormalized_1 = require("../../DataScience/Types/signal-attributes-denormalized");
const auto_resolve_policy_1 = require("../auto-resolve-policy/auto-resolve-policy");
const comparison_spec_1 = require("../comparison-spec");
exports.SignalReviewAttributesRowSchema = signal_attributes_denormalized_1.SignalAttributesDenormalizedSchema.extend({
    modelSignal: z
        .string()
        .nullish()
        .transform((value) => value ?? null),
});
const VALUE_COLUMNS = [
    'power',
    'ground',
    'analog',
    'digital',
    'exposedPad',
    'noConnect',
    'activeLow',
    'direction',
    'description',
    'modelSignal',
];
class SignalAttributesComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['signalName'], VALUE_COLUMNS);
        this.membershipScopeColumns = ['signalName'];
        this.autoResolveColumns = new Map([['description', new auto_resolve_policy_1.PluralityPreferNonEmptyAutoResolvePolicy()]]);
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value) => this.normalize(column, value));
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    normalize(column, value) {
        if (column === 'signalName' && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        return super.normalize(column, value);
    }
}
exports.SignalAttributesComparison = SignalAttributesComparison;
//# sourceMappingURL=signal-attributes.comparison.js.map